import { H1 } from "../components/styles/Styles"

export default function NotFound() {
	return (
		<div>
			<H1>Oops! Not found...</H1>
			<p>The page you requested cannot be found.</p>
		</div>
	)
}
